"use client";

import Image from "next/image";
import { useBranding } from "@/app/_module/store/contexts/brandingContext";

interface InsuraCentralLogoProps {
  size?: number;
  className?: string;
}

/**
 * InsuraCentral Logo Component
 * Displays the favicon logo with fallback to first letter if image is not available
 */
export const InsuraCentralLogo = ({ size = 32, className = "" }: InsuraCentralLogoProps) => {
  const { branding } = useBranding();
  const fallbackLetter = branding.brandName.charAt(0);

  return (
    <div
      className={`bg-white rounded flex items-center justify-center flex-shrink-0 relative overflow-hidden ${className}`}
      style={{ width: size, height: size }}
    >
      <Image
        src={branding.logoUrl || branding.faviconUrl || "/favicon.png"}
        alt={branding.brandName}
        width={size}
        height={size}
        className="object-contain"
        onError={(e) => {
          // Fallback to first letter if logo doesn't exist
          e.currentTarget.style.display = 'none';
          const fallback = e.currentTarget.parentElement?.querySelector('.fallback-logo');
          if (fallback) {
            (fallback as HTMLElement).style.display = 'block';
          }
        }}
      />
      <span className="fallback-logo text-sm font-bold text-blue-600 hidden">{fallbackLetter}</span>
    </div>
  );
};

export default InsuraCentralLogo;
